module.exports = __webpack_public_path__ + "img/NPCM.76c085d8.png";